import React from "react";
import { Modal } from "antd";

import StateDetailsComponent from "../../../components/StateDetailsComponent/StateDetailsComponent";
import authorization from "../../../auth/authorization";
import AddState from "./AddStates";
import EditState from "./EditState";

export const StateFormModal = ({
  open,
  editId,
  userType,
  onCancel,
  addState,
  afterStateEdit,
  fetchStatesAfterUpdate,
  states,
  telemedicineCategory,
  consultationType,
  listOfPharmacies,
  fetchPharmacies,
  pharmacyLoading,
}) => (
  <Modal
    title={editId ? "Edit State" : "Add State"}
    open={open}
    footer={null}
    width="min(1200px, calc(100vw - 48px))"
    destroyOnClose
    onCancel={onCancel}
    style={{ top: 24 }}
    bodyStyle={{ height: "calc(100vh - 120px)", maxHeight: "calc(100vh - 120px)", overflow: "hidden", padding: 16 }}
  >
    {editId && authorization.isAllowed(userType, "updateState") ? (
      <EditState
        stateId={editId}
        afterStateEdit={afterStateEdit}
        fetchStatesAfterUpdate={fetchStatesAfterUpdate}
        states={states}
        telemedicineCategory={telemedicineCategory}
        consultationType={consultationType}
        listOfPharmacies={listOfPharmacies}
        fetchPharmacies={fetchPharmacies}
        pharmacyLoading={pharmacyLoading}
      />
    ) : (
      <AddState
        addState={addState}
        states={states}
        telemedicineCategory={telemedicineCategory}
        consultationType={consultationType}
        listOfPharmacies={listOfPharmacies}
        fetchPharmacies={fetchPharmacies}
        pharmacyLoading={pharmacyLoading}
        onCancel={onCancel}
      />
    )}
  </Modal>
);

export const StateDetailsModal = ({ open, stateDetailId, onCancel }) => (
  <Modal
    destroyOnClose
    width="min(1200px, calc(100vw - 48px))"
    open={open}
    onOk={onCancel}
    onCancel={onCancel}
    footer={[]}
    style={{ top: 24 }}
    bodyStyle={{ maxHeight: "calc(100vh - 120px)", overflow: "auto", padding: 16, display: "flex", flexDirection: "column" }}
  >
    <StateDetailsComponent stateDetailId={stateDetailId} />
  </Modal>
);
